<style scoped>
.link {
  width: 100%;
}
</style>
<template>
  <div class="ml-3 relative" @blur.capture="blur">
    <button
      class="max-w-xs flex items-center text-sm rounded-full text-white focus:outline-none focus:shadow-solid"
      :aria-label="$t('dashboard.user_menu')"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      aria-controls="user-menu-options"
      @click="toggle"
    >
      <img
        v-if="user.pictureUrl"
        class="h-8 w-8 rounded-full"
        :src="user.pictureUrl"
        :alt="`Profile image of ${user.fullName}`"
      />
      <span
        v-if="!user.pictureUrl"
        class="inline-block h-8 w-8 rounded-full overflow-hidden bg-gray-100"
      >
        <svg
          class="h-full w-full text-gray-300"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
          ></path>
        </svg>
      </span>
    </button>
    <div
      v-if="isOpen"
      id="user-menu-options"
      class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
    >
      <div class="py-1 rounded-md bg-white shadow-xs">
        <form method="POST" action="/oidc/logout/">
          <input type="hidden" name="csrfmiddlewaretoken" :value="csrftoken" />
          <button
            type="submit"
            class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
          >
            {{ $t('dashboard.logout') }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserMenu',
  props: {
    user: Object,
    csrftoken: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    blur(e) {
      if (this.$el.contains(e.relatedTarget)) return;
      this.isOpen = false;
    },
  },
};
</script>
